import { Component, OnInit } from '@angular/core';
import { LoadingController, ModalController, NavParams, ToastController } from '@ionic/angular';
import { UserService } from '@shared/services/user.service';
import { UtilService } from '@shared/utils/util';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-validate-profile',
  templateUrl: './validate-profile.component.html',
  styleUrls: ['./validate-profile.component.scss'],
})
export class ValidateProfileComponent  implements OnInit {
  userData:any;
  constructor(private modalCtrl: ModalController,
    private navParams: NavParams,
    private userService: UserService,
    private toastCtrl: ToastController,
    public translate: TranslateService,
    private util: UtilService,
    private loadingCtrl: LoadingController
  ) { }

  ngOnInit() {
    this.userData = this.navParams.get('me');
  }

  async openValidation(){
    this.modalCtrl.dismiss('openValidation');
  }

  goBack(){
    this.modalCtrl.dismiss()
  }

}
